export const API_URL = process.env.VUE_APP_API_URL;
export const API_URL_STATIC = process.env.VUE_APP_API_URL_STATIC;
export const APP_NAME = process.env.VUE_APP_TITLE;
export const LAYOUT_ADMIN = "admin";
export const LAYOUT_AUTH = "auth";
export const DEFAULT_TIMEOUT = 120000;
export const EXTENDED_TIMEOUT = 600000000;
export const NO_TIMEOUT = 0;